import React from 'react'
import { connect } from 'react-redux'
import type { Maybe } from '@adc/sdk/types'
import type {
  primitives,
  AuctionBlueprintOnlineReactiveArgs,
  AuctionBlueprintScheduledOnlineReactiveArgs,
} from '@adc/blueprint'
import AuctionStatusNotification from 'common/components/auctionStatusNotification'
import BidAgain from 'common/modules/bidBanner/bidAgain'
import { enums } from '@adc/sdk'
import { FeatureFlags, useListingContext } from '../../context/listing'
import Before from './states/before'
import During from './states/during'
import Won from './states/won'

export const showTPSOnlineBidBanner = (
  segment: Maybe<AuctionBlueprintScheduledOnlineReactiveArgs['segment']>,
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
): boolean => {
  return Boolean(
    listing?.is_current_user_registered_for_online_auction &&
      (segment?.__methods__?.isOnlineAuctionActive() ||
        segment?.__methods__?.isProxyBiddingActive(listing) ||
        segment?.current_user_bidding_status ===
          enums.OnlineAuctionSegmentBiddingStatus.Won)
  )
}

// TODO: fill up the rest of this interface, will need to see what <During which props is spread into is using so we can make it explicit and stop the props spreading
interface TpsOnlineBidBannerProps {
  featureFlags: FeatureFlags
  user: primitives.AuctionUser
}

const TPSOnlineBidBanner = (props: TpsOnlineBidBannerProps) => {
  const { featureFlags, user } = props
  const { segment, listing } = useListingContext()
  const renderTpsOnlineBidBanner = () => {
    if (!showTPSOnlineBidBanner(segment, listing)) {
      return null
    }
    if (segment?.__methods__?.isProxyBiddingActive(listing)) {
      return <Before featureFlags={featureFlags} user={user} />
    } else if (segment?.__methods__?.isOnlineAuctionActive()) {
      return (
        <>
          <BidAgain />
          <During {...props} />
        </>
      )
    } else if (
      segment?.current_user_bidding_status ===
      enums.OnlineAuctionSegmentBiddingStatus.Won
    ) {
      return <Won />
    } else return null
  }

  return (
    <>
      <AuctionStatusNotification listing={listing} />
      <>{renderTpsOnlineBidBanner()}</>
    </>
  )
}

const mapStateToProps = (store: any) => ({
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  featureFlags: store.featureFlags,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  user: store.user,
})

export default connect(mapStateToProps)(TPSOnlineBidBanner)
